import React, { useState, useEffect } from 'react';
import { Bell, CheckCircle, Info, AlertTriangle, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import api from '../../api/axios';
import styles from './Notifications.module.css';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/users/notifications');
      setNotifications(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      toast.error('Failed to load notifications');
      setLoading(false);
    }
  };

  const markAllRead = async () => {
    try {
      await api.put('/users/notifications/read');
      setNotifications(notifications.map(n => ({ ...n, read: true })));
      toast.success('All notifications marked as read');
    } catch (err) {
      toast.error('Failed to mark notifications as read');
    }
  };

  const deleteNotification = async (id) => {
    try {
      await api.delete(`/users/notifications/${id}`);
      setNotifications(notifications.filter(n => n._id !== id));
      toast.success('Notification deleted');
    } catch (err) {
      toast.error('Failed to delete notification');
    }
  };

  const getIcon = (type) => {
    switch (type) {
      case 'alert': return <AlertTriangle size={20} className={styles.iconAlert} />;
      case 'success': return <CheckCircle size={20} className={styles.iconSuccess} />;
      default: return <Info size={20} className={styles.iconInfo} />;
    }
  };

  return (
    <div className={styles.container}>
      <PageHeader 
        title="Security Notifications" 
        breadcrumb={['Resources', 'Notifications']} 
        actionButton={
          <button className={styles.secondaryBtn} onClick={markAllRead}>
            <CheckCircle size={16} /> Mark all as read
          </button>
        }
      />

      <div className={styles.list}>
        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
        ) : notifications.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>No notifications found.</div>
        ) : (
          notifications.map(notif => (
            <div key={notif._id} className={`${styles.notifItem} ${!notif.read ? styles.unread : ''}`}>
              <div className={styles.iconWrapper}>
                {getIcon(notif.type)}
              </div>
              <div className={styles.content}>
                <h4>{notif.title}</h4>
                <p>{notif.message}</p>
                <span className={styles.time}>{new Date(notif.createdAt).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}</span>
              </div>
              {!notif.read && <div className={styles.unreadDot}></div>}
              <button className={styles.deleteBtn} onClick={() => deleteNotification(notif._id)}>
                <Trash2 size={16} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Notifications;
